import { JSX } from 'react';

import { Text } from '@videoblocks/design-system';

export interface TextInputCharacterCounterProps {
    current: number;
    max: number;
}

export const TextInputCharacterCounter = ({ current, max }: TextInputCharacterCounterProps): JSX.Element => {
    return (
        <Text className="text-neutral-dark-800" fontSize="sm" fontWeight="regular">
            {
                <>
                    {current?.toLocaleString()}/{max?.toLocaleString()} characters
                </>
            }
        </Text>
    );
};
